import { render, staticRenderFns } from "./picsTop.vue?vue&type=template&id=1dee6dc6&"
import script from "./picsTop.vue?vue&type=script&lang=js&"
export * from "./picsTop.vue?vue&type=script&lang=js&"
import style0 from "./picsTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports